import {
  WithLoggedInAuthInfoProps,
  withRequiredAuthInfo,
} from "@propelauth/react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import React, { useContext, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import { fetchWithToken } from "../../api/apiBase";
import { QAModel } from "../qa_forum/QAModel";
import { ScrollArea } from "../ui/scroll-area";
import { Button } from "../ui/button";
import { dateFormatter } from "../../lib/formatters";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";
import {ProjectContext} from "../../contexts/ProjectContext";

/**
 *
 * todo -
 * todo - style the Cards ..
 * todo - backend - this probably should come in with the project schema...
 * */

type QaWidgetProps = {
  renderOnHomePage?: boolean
} & WithLoggedInAuthInfoProps

function QAWidget({accessToken, renderOnHomePage=false}: QaWidgetProps) {
  const navigate = useNavigate();
  const { project_id } = useParams<string>();
  const projectContext = useContext(ProjectContext);

  const { data, error, isLoading } = useSWR(
    [`/projects/${project_id}/qa/?skip=0&limit=3`, accessToken],
    ([url, token]) => fetchWithToken(url, token)
  );

  if (isLoading && !renderOnHomePage) {
    return <div><BaseLoadingSpinner/></div> 
  } else if (isLoading) return <p></p>;
  if (error)
    return (

      <div>Error loading QA</div>

    );

  return (
    <Card className="">
      <CardHeader>
        <CardTitle>
          <div className="flex justify-between items-center">
            <div>Latest Questions and Answers</div>
            <div className="flex space-y-2 flex-col [250px]:flex-row [250px]:space-x-2">
              {projectContext?.role === "builder" ? (
                <Button
                    variant="outline"
                  onClick={() => navigate(`/project/${project_id}/qa/new`)}
                >Ask a Question</Button>
              ) : (
                <></>
              )}
              <Button
                variant="outline"
                onClick={() => navigate(`/project/${project_id}/qa`)}
              >
                More
              </Button>
            </div>
          </div>
        </CardTitle>
      </CardHeader>

      <CardContent className="p-4">
        <ScrollArea className="h-64 rounded-md border border-gray-300 overflow-auto">
          <div className="flex flex-col gap-2">
            {data.map((qa: QAModel) => (
              <Card
                key={qa.id}
                className="hover:bg-gray-50 transition duration-200 ease-in-out rounded-lg shadow-sm p-1"
              >
                <CardContent className="p-0 px-2">
                  <div className="flex justify-between items-center mb-2">
                    <Link
                      className="text-lg font-semibold hover:underline"
                      to={`/project/${project_id}/qa/${qa.id}`}
                    >
                      #{qa.number} - {qa.title}
                    </Link>
                    <p className="text-xs text-gray-500">
                      {dateFormatter.format(new Date(qa.created_at))}
                    </p>
                  </div>
                  <p className="text-sm text-gray-700">{qa.body}</p>
                  <p className="text-xs text-gray-500 text-right">
                    - {qa.created_by.name}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}

export default withRequiredAuthInfo(QAWidget);
